import { MCP_CLIENT_CONFIG, MCP_DEFAULT_SERVER_NAME } from '@/core/const/mcpGateway.const'
import { buildMcpUrl } from '@/core/utils/buildMcpUrl'
import { replacePlaceholders } from '@/core/utils/installation'

import type { BuildMcpClientConfigParams } from '../interfaces/buildMcpClientConfigParams.interface'

export { buildMcpUrl } from '@/core/utils/buildMcpUrl'

export const buildMcpClientConfig = ({
  gatewayPath,
  gatewayMcpPort,
  isSecured,
  projectName,
}: BuildMcpClientConfigParams): string => {
  const mcpUrl = buildMcpUrl(gatewayPath, gatewayMcpPort, isSecured)
  const serverName = projectName?.trim() || MCP_DEFAULT_SERVER_NAME

  return replacePlaceholders(MCP_CLIENT_CONFIG, { mcpUrl, serverName })
}
